import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import InputText from './inputText';

class BioForm extends Component {
  constructor(props) {
    super(props);
    this.onDataChange = this.onDataChange.bind(this);
    this.state = { open: false, data: this.props.data }
    this.original = JSON.parse(JSON.stringify(this.props.data))
  }

  onCloseModal = () => {
    this.setState({ data: JSON.parse(JSON.stringify(this.original)), open: false });    
};

  onDataChange(evt) {
    
    const id = evt.target.id
    const val = evt.target.value

    let state = this.state;
    state.data[id] = val;

    this.setState(state);
    
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data) {
        this.setState({data: this.props.data});
    }
}
  render() {
    var { data } = this.state;
    if (!data.bio) data.bio = "";
    
    return (
      <div className="box">
        <div className="box-title">
          <h3>{this.props.title} &nbsp;&nbsp;<button className="badge badge-info" onClick={() => {this.setState({open: true})}}>Edit Bio</button></h3>
        </div>
        <div className="box-content">
          <>
            {data.bio ?
            <p>
              {`${data.bio}`}
            </p>
            :
            <p>No Bio written</p>
            }
          </>
          <Modal open={this.state.open} onClose={this.onCloseModal} >
            <div className="modal-header">
              <h5 className="modal-title f-w-600" id="exampleModalLabel2">Update Bio</h5>
            </div>
            <div className="modal-body">
              <div className="container">
                <div className="card">
                  <div className="card-body">
                  <div className="row align-self-center text-center">
                        <div className="col-lg-12 col-sm-12">
                            <InputText style={{color: "slate", fontSize: "16px"}} rows={10} label="Please enter a short biographical note:"  id="bio" value={data.bio} onChange={this.onDataChange} placeholder="" />
                        </div>                               
                    </div> 
                  </div>
                </div>        
              </div>
            </div>
            <div className="modal-footer">              
              <button type="button" className="btn btn-secondary" onClick={this.onCloseModal}>Cancel</button>
              <button type="button" className="btn btn-primary" onClick={() => { this.setState({open: false}); this.props.onCloseModal('bio', this.state.data)}}>Approve</button>
            </div>
          </Modal>
        </div>
      </div>

      );
  }
}

export default BioForm;